import { FunctionComponent, useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';

import { TranslatableText } from '@dreryk/react-common';
import { Message, MessageOptions } from '@dreryk/react-components';

export enum AppointmentStatusType {
   POSITIVE = 'POSITIVE',
   NEGATIVE = 'NEGATIVE',
   PLANNED = 'PLANNED',
   DURING = 'DURING',
   DISABLED = 'DISABLED',
}

const createAppointmentMessageOptions = (theme: DefaultTheme): MessageOptions<typeof AppointmentStatusType> => ({
   [AppointmentStatusType.POSITIVE]: {
      color: theme.success,
      backgroundColor: theme.successLighter,
   },
   [AppointmentStatusType.NEGATIVE]: {
      color: theme.error,
      backgroundColor: theme.errorLighter,
   },
   [AppointmentStatusType.PLANNED]: {
      color: theme.primary,
      backgroundColor: theme.primaryLighter,
   },
   [AppointmentStatusType.DURING]: {
      color: theme.info,
      backgroundColor: theme.infoLighter,
   },
   [AppointmentStatusType.DISABLED]: {
      color: theme.background,
      backgroundColor: theme.backgroundLighter,
   },
});

type AppointmentStatusProps = {
   readonly label?: TranslatableText;
   readonly type: AppointmentStatusType;
};

const useOptions = (): MessageOptions<typeof AppointmentStatusType> => {
   const theme = useTheme();
   return useMemo(() => createAppointmentMessageOptions(theme), [theme]);
};

const AppointmentStatus: FunctionComponent<AppointmentStatusProps> = (props) => {
   const options = useOptions();

   return (
      <Message displayIndicator type={props.type} options={options} label={props.label} testId={'appointmentStatus'} />
   );
};

export { AppointmentStatus };
